import React from 'react'

import { ArrowCirclePathRightIcon, IconSizes } from '@inno-ui/icons'
import clsx from 'clsx'
import { FallbackProps } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'

import styles from '../WidgetsErrorBoundary.module.scss'
import { DefaultErrorFallbackProps } from '../WidgetsErrorBoundary.types'

export const DefaultErrorFallback: React.FC<
  FallbackProps & DefaultErrorFallbackProps
> = ({ resetErrorBoundary, orientation = 'vertical' }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'widgets.error' })

  const isHorizontal = orientation === 'horizontal'

  return (
    <div className={styles.errorContainer}>
      <div
        className={clsx(styles.errorContent, {
          [styles.horizontal]: isHorizontal
        })}
      >
        <div className={styles.icon}>⚠️</div>
        <div
          className={clsx(styles.textContainer, {
            [styles.textContainerVertical]: !isHorizontal
          })}
        >
          <h3 className={styles.title}>{t('title')}</h3>
          <p className={styles.message}>{t('message')}</p>
        </div>
        {resetErrorBoundary && (
          <button
            type='button'
            onClick={resetErrorBoundary}
            className={clsx(styles.retryButtonIcon, {
              [styles.retryButton]: !isHorizontal
            })}
            aria-label={t('retry')}
          >
            {isHorizontal ? (
              <ArrowCirclePathRightIcon
                size={IconSizes.Size20}
                color='currentColor'
              />
            ) : (
              t('retry')
            )}
          </button>
        )}
      </div>
    </div>
  )
}
